import { SettingsTitlePanel } from 'pages/SettingsPage/components/SettingsTitlePanel';

import { DivWithLoader } from 'components/UIComponents/DivWithLoader/DivWithLoader';
import { TabsVerticalPanel } from '../../../../components/TabsVerticalPanel/TabsVerticalPanel';
import { SettlementsTemplateRestoreConfirm } from './DialogWindows/SettlementsTemplateRestoreConfirm';
import { SettlementsTemplateSaveConfirm } from './DialogWindows/SettlementsTemplateSaveConfirm';
import './SettlementsEmailTemplates.css';
import { SettlementsEmailTemplatesContent } from './SettlementsEmailTemplatesContent';
import { useSettlementsEmailTemplates } from './useSettlementsEmailTemplates';

interface Props {}

export const SettlementsEmailTemplates = (props: Props) => {
  const {
    loading,
    menuList,
    menuSelected,
    template,
    canSave,
    dialogRestoreConfirm,
    dialogSaveConfirm,
    setMenuSelected,
    change,
    save,
    restore,
  } = useSettlementsEmailTemplates();

  return (
    <DivWithLoader loading={loading} className="settlements-email-templates">
      <SettingsTitlePanel title="Email templates">
        <TabsVerticalPanel
          items={menuList}
          selected={menuSelected}
          onChange={setMenuSelected}
        >
          <SettlementsEmailTemplatesContent
            value={template}
            canSave={canSave}
            onChange={change}
            onSaveClick={save}
            onRestoreClick={restore}
          />
        </TabsVerticalPanel>
      </SettingsTitlePanel>

      {dialogSaveConfirm && (
        <SettlementsTemplateSaveConfirm
          title={dialogSaveConfirm.title ?? ''}
          warning={`Your changes will be lost if you don't save them`}
          onConfirm={dialogSaveConfirm.onConfirm}
        />
      )}

      {dialogRestoreConfirm && (
        <SettlementsTemplateRestoreConfirm
          title="Are you sure you want to restore the default template?"
          warning="The content from your current template will be deleted. This action is not reversible"
          subject={dialogRestoreConfirm.subject}
          template={dialogRestoreConfirm.template}
          onConfirm={dialogRestoreConfirm.onConfirm}
        />
      )}
    </DivWithLoader>
  );
};
